import React, { createContext, useState } from "react";

export const ModalContext = createContext();

export function ModalProvider({ children }) {
  const [isPlaylistModalOpen, setPlaylistModalOpen] = useState(false);

  return (
    <ModalContext.Provider value={{ isPlaylistModalOpen, setPlaylistModalOpen }}>
      {children}
    </ModalContext.Provider>
  );
}
